import {
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
} from '@dixa/lib-shared-habla';
import { ArticleDataContext } from 'articleEditor/contexts/articleDataProvider';
import useArticleEditorBackLink from 'articleEditor/hooks/useArticleEditorBackLink';
import { ArticleDeleteModal } from 'collection/pages/collectionEdit/components/modals/articleDeleteModal';
import { useAtomValue } from 'jotai';
import { useArticleNoIndexUpdateMutation } from 'lib-knowledge-management-common/graphql';
import { useModal } from 'lib-knowledge-modal';
import { useNotification } from 'lib-knowledge-utils/hooks/useNotification';
import { featureFlagsAtom } from 'lib-knowledge-utils/stores/featureFlags';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import s from './headerControls.module.scss';
import TimeAgo from './timeAgo';

export const ActionsDropdown = (): JSX.Element | null => {
  const { showModal } = useModal();
  const navigate = useNavigate();
  const { to } = useArticleEditorBackLink();
  const article = useContext(ArticleDataContext);
  const [updateNoIndex] = useArticleNoIndexUpdateMutation();
  const { errorNotify } = useNotification();
  const { featureFlags } = useAtomValue(featureFlagsAtom);
  if (!article) {
    return null;
  }

  return (
    <DropdownButton
      noArrow
      icon="dots-h"
      dropdownProps={{
        closeOnBlur: true,
      }}
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ toggleDropdown }) => (
            <ButtonList>
              {featureFlags.seoMeta && (
                <ButtonList.Item
                  icon={article.noIndex ? 'eye' : 'eye-slash'}
                  onClick={async () => {
                    toggleDropdown();

                    const noIndex = !article.noIndex;
                    try {
                      await updateNoIndex({
                        variables: { articleId: article.id, noIndex },
                        optimisticResponse: {
                          __typename: 'Mutations',
                          articleUpdate: { ...article, noIndex },
                        },
                      });
                    } catch {
                      errorNotify({
                        text: 'Changing the search engine visibility failed',
                      });
                    }
                  }}
                >
                  {article.noIndex
                    ? 'Show in search engines'
                    : 'Hide from search engines'}
                </ButtonList.Item>
              )}
              <ButtonList.Item
                buttonClassName={s.buttonWarning}
                className={s.buttonWarning}
                icon="trash"
                onClick={() => {
                  toggleDropdown();

                  showModal(ArticleDeleteModal, {
                    articleId: article.id,
                    onDelete: () => navigate(to),
                  });
                }}
              >
                Permanently delete
              </ButtonList.Item>

              <ButtonList.Divider />
              {article.updatedAt && article.updatedBy && (
                <TimeAgo
                  labelPrefix="Last edited by"
                  at={article.updatedAt}
                  by={article.updatedBy}
                />
              )}
            </ButtonList>
          )}
        </DropdownButtonContext.Consumer>
      }
    ></DropdownButton>
  );
};
